<template>
  <div id="item">
    <div class="container">

      <div class="page-title">
        <span class="name">Tunnel</span>
        <button class="save btn btn-primary" @click="save">{{ $t("save") }}</button>
      </div>

      <Tabs>
        <TabSection title="Tunnel Configuration" v-if="ready" collapsible>
          <div class="column">
            <div>
              <div class="group">
                <label>{{ $t('external_pos.url') }}</label>
                <input type="text" v-model="data.tunnel.url">
              </div>
              <div class="group">
                <label>ssh username</label>
                <input type="text" v-model="data.tunnel.sshUsername">
              </div>
              <div class="group">
                <label>ssh key</label>
                <input type="text" v-model="data.tunnel.sshKey">
              </div>
              <div class="group">
                <label>port</label>
                <div style="display: flex">
                  <input style="flex-grow: 1" type="number" v-model="data.tunnel.port" disabled>
                  <button style="margin-left: 5px" class="btn btn-primary" @click="changePort"
                    :disabled="!data.tunnel.port">{{ $t('external_pos.change_port') }}</button>
                </div>
              </div>
            </div>
          </div>
        </TabSection>
      </Tabs>

    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: "SettingsTunnel",

    data() {
      return {
        companyId: null,
        branchId: null,
        ready: false,
        data: {
          tunnel: {
            id: null,
            url: 'tunnel.ishopfood.com',
            port: null,
            sshUsername: "",
            sshKey: "",
          },
        }
      }
    },

    watch: {

    },

    mounted() {
      this.companyId = this.$route.query.company;
      this.branchId = this.$route.query.branch;
      this.$store.commit('showSpinner', true);
      Promise
        .all([
          this.getCompanyExternalPos({ companyId: this.companyId, branchId: this.branchId })
        ])
        .then(([externalPosData]) => {
          if (externalPosData) {
            this.data.tunnel = externalPosData.tunnel || this.data.tunnel;
            this.ready = true
          } else {
            toast(this.$t("error.no_server"), "error");
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.$store.commit('showSpinner', false);
        })
    },

    methods: {
      ...mapActions(["saveCompanyTunnel", "getCompanyExternalPos"]),

      async changePort() {
        let data = {
          assignNextPort: true
        };
        this.$store.commit('showSpinner', true);
        let response = await this.saveCompanyTunnel({ branchId: this.branchId, companyId: this.companyId, data });
        this.$store.commit('showSpinner', false);
        if (response) {
          this.data.tunnel = response;
          toast(this.$t("success"), "success");
        } else {
          toast(this.$t("error.no_server"), "error");
        }
      },

      async save() {
        let data = JSON.parse(JSON.stringify(this.data.tunnel));
        if (!data.port) {
          delete data.port;
          data.assignNextPort = true
        }
        this.$store.commit('showSpinner', true);
        let response = await this.saveCompanyTunnel({ branchId: this.branchId, companyId: this.companyId, data });
        this.$store.commit('showSpinner', false);
        if (response) {
          this.data.tunnel = response;
          toast(this.$t("success"), "success");
        } else {
          toast(this.$t("error.no_server"), "error");
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  #report {
    width: 100%;

    td,
    th {
      padding: 4px 4px;
      text-align: left;
    }

    th {
      white-space: nowrap;
      background-color: #ddd;
    }

    tr:nth-child(odd) {
      background-color: #eee;
    }

    tr {
      page-break-inside: avoid;
    }
  }
</style>